export interface AddAirportContractAdditionalFee {
    fuelFeeId: number;
    price: number;
    currencyId: number | null;
    unitConverterId: number | null;
}
